module.exports = __webpack_public_path__ + "img/1.b91118f4.png";